import type { SupportedRepubName } from '@cx-web/domain-types';

export type ErrorPageConfig = {
  backgroundColor: string;
  customComponent?: string; // Component identifier (e.g., 'ErrorWhoScored')
  redirectUrl?: string; // URL to redirect to on 404 (e.g., for GZ)
};

/**
 * Error page configurations for each republic
 */
export const ERROR_PAGE_CONFIGS = {
  WS: {
    backgroundColor: '#2d2d2d',
    customComponent: 'ErrorWhoScored',
  },
  GZ: {
    backgroundColor: '#f5f5f5',
    redirectUrl: 'https://www.gazzetta.it/404.shtml',
  },
} satisfies Partial<Record<SupportedRepubName, ErrorPageConfig>>;
